import { apiPaths, getApiPath, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET
export const GET_GLOBAL_PARAMETERS_SUCCESS = 'GET_GLOBAL_PARAMETERS_SUCCESS'
export const GET_GLOBAL_PARAMETERS_FAILURE = 'GET_GLOBAL_PARAMETERS_FAILURE'

// -- CREATE
export const CREATE_GLOBAL_PARAMETER_SUCCESS = 'CREATE_GLOBAL_PARAMETER_SUCCESS'
export const CREATE_GLOBAL_PARAMETER_FAILURE = 'CREATE_GLOBAL_PARAMETER_FAILURE'

// -- UPDATE
export const UPDATE_GLOBAL_PARAMETER_SUCCESS = 'UPDATE_GLOBAL_PARAMETER_SUCCESS'
export const UPDATE_GLOBAL_PARAMETER_FAILURE = 'UPDATE_GLOBAL_PARAMETER_FAILURE'

// -- DELETE
export const DELETE_GLOBAL_PARAMETER_SUCCESS = 'DELETE_GLOBAL_PARAMETER_SUCCESS'
export const DELETE_GLOBAL_PARAMETER_FAILURE = 'DELETE_GLOBAL_PARAMETER_FAILURE'

// -- SELECT
export const SELECT_GLOBAL_PARAMETERS = 'SELECT_GLOBAL_PARAMETERS'

// -----------------------------------------------------------------------------

/**
 * GET the list of all global parameter's attributes.
 *
 * @returns {Promise<array<object>>}
 */
export const getGlobalParameters = () => async (dispatch) => {
  const path = apiPaths.GLOBAL_PARAMETER_LIST
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalParametersActions.getGlobalParameters()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_GLOBAL_PARAMETERS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_GLOBAL_PARAMETERS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a new global parameter's attribute.
 *
 * @param {object} newParameter New global parameter attribute object to create.
 * @returns {Promise<object>}
 */
export const createGlobalParameter = (newParameter) => async (dispatch) => {
  const path = apiPaths.GLOBAL_PARAMETER_CREATE
  const api = new Api(path)
  const result = await api.create(newParameter)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalParametersActions.createGlobalParameter()', {
    path,
    newParameter,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_GLOBAL_PARAMETER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_GLOBAL_PARAMETER_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific global parameter's attribute based on its parameter ID
 *
 * @param {object} newParameter Object to set instead of the previous one.
 * @param {uui} mid Parameter ID to update
 * @returns {Promise<object>}
 */
export const updateGlobalParameter = (newParameter, mid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_PARAMETER_UPDATE, { mid })
  const api = new Api(path)
  const result = await api.update(newParameter)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalParametersActions.updateGlobalParameter()', {
    path,
    newParameter,
    result
  })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_GLOBAL_PARAMETER_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_GLOBAL_PARAMETER_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific global parameter's attribute based on its parameter ID.
 *
 * @param {uuid} mid Parameter ID to delete.
 * @returns {Promise<string>}
 */
export const deleteGlobalParameter = (mid) => async (dispatch) => {
  const path = getApiPath(apiPaths.GLOBAL_PARAMETER_DELETE, { mid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalParametersActions.deleteGlobalParameter()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_GLOBAL_PARAMETER_SUCCESS,
      data: mid
    })
  }
  return dispatch({
    type: DELETE_GLOBAL_PARAMETER_FAILURE,
    data: result.data
  })
}

/**
 * SELECT a list of global parameter UUID.
 *
 * @param {array<uuid>} data Array of global parameter UUID to select.
 * @returns {Promise<array<object>>}
 */
export const selectListGlobalParameters = (data) => async (dispatch) => {
  Logger.trace(LoggerTypes.ACTION, '[ACTION] globalParametersActions.selectListGlobalParameters()', { data })
  return dispatch({
    type: SELECT_GLOBAL_PARAMETERS,
    data
  })
}
